module.exports = __webpack_public_path__ + "assets/img/2.f7c85832.png";